/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { wrapApiCall } from '@/lib/axios'
import type { AxiosInstance } from 'axios'
import {
  CancelFreezePayload,
  CreateFreezePayload,
  CreateMemberFreezePayload,
  FreezePreview,
  MemberEditFreezeResult,
  MemberFreezeResult,
  MemberUnfreezeResult,
  MembershipFreeze,
  UpdateFreezeGroupPayload,
  UpdateFreezePayload,
} from './model'

export const MemberFreezeService = (client: AxiosInstance) => ({
  async getFreezesForMembership(userMembershipId: number): Promise<MembershipFreeze[]> {
    const { data } = await wrapApiCall(() =>
      client.get('/membership-freezes', { params: { userMembershipId } })
    )
    return data ?? []
  },

  async getFreezesForUser(userId: number): Promise<MembershipFreeze[]> {
    const { data } = await wrapApiCall(() =>
      client.get('/membership-freezes', { params: { userId } })
    )
    return data ?? []
  },

  async previewFreeze(
    userMembershipId: number,
    startDate: string,
    endDate: string,
    excludeFreezeId?: number
  ): Promise<FreezePreview> {
    const { data } = await wrapApiCall(() =>
      client.get('/membership-freezes/preview', {
        params: { userMembershipId, startDate, endDate, excludeFreezeId },
      })
    )
    return data
  },

  async createFreeze(payload: CreateFreezePayload): Promise<MembershipFreeze> {
    const { data } = await wrapApiCall(() => client.post('/membership-freezes', payload))
    return data
  },

  async cancelFreeze(id: number, payload: CancelFreezePayload): Promise<MembershipFreeze> {
    const { data } = await wrapApiCall(() =>
      client.patch(`/membership-freezes/${id}/cancel`, payload)
    )
    return data
  },

  async updateFreeze(id: number, payload: UpdateFreezePayload): Promise<MembershipFreeze> {
    const { data } = await wrapApiCall(() => client.patch(`/membership-freezes/${id}`, payload))
    return data
  },

  // ── Member-level freeze (QTY-1773/1774/1775) ────────────────────────────

  async createMemberFreeze(
    memberId: number,
    payload: CreateMemberFreezePayload
  ): Promise<MemberFreezeResult[]> {
    const { data } = await wrapApiCall(() =>
      client.post(`/membership-freezes/member/${memberId}`, payload)
    )
    return data ?? []
  },

  async cancelMemberFreeze(memberId: number): Promise<MemberUnfreezeResult[]> {
    const { data } = await wrapApiCall(() =>
      client.post(`/membership-freezes/member/${memberId}/unfreeze`)
    )
    return data ?? []
  },

  async updateFreezeGroup(
    memberId: number,
    freezeGroupId: string,
    payload: UpdateFreezeGroupPayload
  ): Promise<MemberEditFreezeResult[]> {
    const { data } = await wrapApiCall(() =>
      client.put(`/membership-freezes/member/${memberId}/freeze-group/${freezeGroupId}`, payload)
    )
    return data ?? []
  },
})
